import { escapeHtml } from "./text.ts";

export interface DisclosureOptions {
  id: string;
  label: string;
  summary?: string;
  content: string;
  open?: boolean;
  className?: string;
}

export function panelFrame(label: string, toolbar: string, content: string, className = ""): string {
  return `<aside class="detail-panel ui-panel ${className}" aria-label="${label}"><div class="detail-panel__scroll">${toolbar}<div class="ui-panel__body">${content}</div></div></aside>`;
}

export function disclosure(options: DisclosureOptions): string {
  const classes = ["ui-disclosure", options.className].filter(Boolean).join(" ");
  return `<details class="${classes}" data-disclosure="${options.id}" ${options.open ? "open" : ""}><summary><span><strong>${options.label}</strong>${options.summary !== undefined ? `<small ${options.summary ? "" : "hidden"}>${options.summary}</small>` : ""}</span><svg class="icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></summary><div>${options.content}</div></details>`;
}

export function emptyStateView(title: string, message: string, iconHtml: string, actionHtml = ""): string {
  return `<div class="empty-state" role="status"><div class="empty-icon">${iconHtml}</div><h2>${title}</h2><p>${message}</p>${actionHtml}</div>`;
}

export function menu(label: string, triggerHtml: string, content: string, className = "", description = ""): string {
  return `<details class="ui-menu composer-menu ${className}"><summary class="ui-menu__trigger" aria-label="${label}" title="${label}" aria-haspopup="menu"${description ? ` aria-description="${escapeHtml(description)}"` : ""}>${triggerHtml}</summary><div role="menu">${content}</div></details>`;
}

export function dialogFrame(title: string, subtitle: string, content: string, options: { className?: string; eyebrow?: string } = {}): string {
  return `<div class="ui-dialog__header"><div>${options.eyebrow ? `<p class="eyebrow">${options.eyebrow}</p>` : ""}<h2>${title}</h2>${subtitle ? `<p>${subtitle}</p>` : ""}</div><button class="icon-button" value="cancel" formmethod="dialog" aria-label="Close"><svg class="icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m6 6 12 12M18 6 6 18"/></svg></button></div><div class="ui-dialog__body ${options.className || ""}">${content}</div>`;
}

export function inlineError(message: string): string {
  return `<p class="inline-error" role="alert">${message}</p>`;
}

export function selectionToolbar(count: number, actions: string): string {
  return `<div class="selection-toolbar" role="toolbar" aria-label="Actions for selected items"><strong>${count} selected</strong><div>${actions}</div></div>`;
}

export function toastItem(message: string, error = false, targetDocument: Document = document): HTMLDivElement {
  const item = targetDocument.createElement("div");
  item.className = `toast ${error ? "toast--error" : ""}`;
  item.setAttribute("role", error ? "alert" : "status");
  item.textContent = message;
  return item;
}
